import { Handles, Rail, Slider, Ticks, Tracks } from "react-compound-slider";
import { BiPlus } from "react-icons/bi";

import { weekDays } from "../OperatingHours";
import { Handle, Tick, Track } from "./components";
import { useTranslation } from "react-i18next";

const sliderStyle = {
  position: "relative",
  width: "100%",
  //marginTop: 200,
  height: "55px"
};

const railStyle = {
  position: "absolute",
  width: "100%",
  height: 8,
  borderRadius: 4,
  // cursor: "pointer",
  backgroundColor: "#D7DBDF"
};

const domain = [0, 1439];

const Index = ({
  data = [],
  day,
  addSlide,
  removeSlide,
  updateHandler,
  changeHandler,
  checkValue,
  addNewToEmpty
}: {
  data: number[];
  day: weekDays;
  addSlide: (addEl: any, day: weekDays) => void;
  removeSlide: (removeEl: any, day: weekDays) => void;
  updateHandler: (e: readonly number[], day: weekDays) => void;
  changeHandler: (e: readonly number[], day: weekDays) => void;
  checkValue: (a: number, b: number, day: weekDays) => boolean;
  addNewToEmpty: (day: weekDays) => void;
}) => {
  const { t, i18n } = useTranslation();
  // useEffect(() => {
  //   const twoPairs = splitArrayIntoChunksOfLen(state.arr, 2);

  //   for (let index = 0; index < twoPairs.length; index++) {
  //     const pair = twoPairs[index];

  //     if (onChange) onChange(day, index, pair[0], pair[1]);
  //   }
  // }, [state.arr]);

  // useEffect(() => {
  //   setState({
  //     arr: [
  //       ...state.arr.map((item) =>
  //         convertH2M(
  //           getTimeFromMins(item, day).clone().tz(timezone).format("HH:mm")
  //         )
  //       )
  //     ]
  //   });
  // }, [timezone]);

  const mystyle = {
    marginLeft: "0%",
    marginRight: "0%",
    height: "20px",
    width: "100%",
    marginBottom: "4rem",
    marginTop: "6rem"
  };

  return (
    <div style={mystyle}>
      <p className="my-4 tw-capitalize tw-text-gray-700 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
        {t(`OperationHours/${day}`)}
      </p>

      <Slider
        mode={2}
        step={15}
        domain={domain}
        rootStyle={sliderStyle}
        onUpdate={(e) => updateHandler(e, day)}
        onChange={(e) => changeHandler(e, day)}
        values={data}
        className="timeRangeSlider"
      >
        <Rail>
          {({ getRailProps }) => (
            <div
              style={{
                ...railStyle,
                cursor: data.length <= 0 ? "default" : "pointer"
              }}
              {...getRailProps()}
            />
          )}
        </Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div className="slider-handles">
              {handles.map((handle) => {
                // console.log("handle", handle);

                return (
                  <Handle
                    addSlide={() => addSlide(handle, day)}
                    removeSlide={() => removeSlide(handle, day)}
                    key={handle.id}
                    handle={handle}
                    domain={domain}
                    getHandleProps={getHandleProps}
                  />
                );
              })}
            </div>
          )}
        </Handles>
        <Tracks
          // onChange={(e) => {
          //   console.log("Tracks");
          // }}
          left={false}
          right={false}
        >
          {({ tracks, getTrackProps }) => {
            // console.log("tracks", tracks);
            return (
              <div className="">
                {tracks.map(({ id, source, target }, i) => {
                  // console.log("index", i);
                  return checkValue(source.value, target.value, day) ? (
                    <Track
                      key={id}
                      source={source}
                      target={target}
                      removeSlide={() => removeSlide(target, day)}
                      getTrackProps={getTrackProps}
                    />
                  ) : null;
                })}
              </div>
            );
          }}
        </Tracks>
        <Ticks count={48}>
          {({ ticks }) => (
            <div className="slider-ticks">
              {ticks.map((tick) => (
                <Tick key={tick.id} tick={tick} count={ticks.length} />
              ))}
            </div>
          )}
        </Ticks>
        {data.length <= 0 && (
          <button className="emptyAdd" onClick={() => addNewToEmpty(day)}>
            <BiPlus />
          </button>
        )}
      </Slider>
    </div>
  );
};

export default Index;
